import React, { useState, useEffect } from 'react';
import Styles from "./index.module.css";
import JsonData from "./data.json";
import Join from './join';
import Social from './social';

function AboutBuildeAi() {
    const [pageData, setPageData] = useState({});

    useEffect(() => {
        setPageData(JsonData);
    }, []);

    return (
        <>
            <div className={`${Styles.contentHome}`}>
                <div className={`${Styles.aboutTitle}`}>
                    { pageData?.Header ? pageData.Header.title : '' }
                </div>
                <div className="mb-2">
                    <Join data={pageData?.Join}/>
                </div>
                <div className='mt-5 '>
                    <Social data={pageData?.Social}/>
                </div>
            </div>
        </>
    );
}

export default AboutBuildeAi;